import { io } from "socket.io-client"

const connection_url = process.env.REACT_APP_SOCKET_URL

export const socket = io(connection_url)

socket.on("connect", () => {
  console.log("✅ Socket connected:", socket.id)
})

socket.on("disconnect", reason => {
  console.log("❌ Socket disconnected:", reason)
})

socket.on("connect_error", err => {
  console.error("🚨 Connection error:", err.message)
})
